<script setup lang="ts">
import ChatPresenter from "@/utils/presenters/ChatPresenter.ts";
import ChatMessagePanel from "@/components/navBar/chat/ChatMessagePanel.vue";

const props = defineProps<{
  presenter: ChatPresenter;
  isOtherUserOnline: boolean;
}>();

const emit = defineEmits<{
  toggleChatInfo: [];
}>();


</script>

<template>
  <template v-if="presenter.currentChatMetadata.value">
    <ChatMessagePanel :presenter="presenter"
                      :is-other-user-online="isOtherUserOnline"
                      @toggleChatInfo="emit('toggleChatInfo')"/>
  </template>
</template>
